function formatMillisecondsToTimeUnit(ms: number): {
  day: number;
  hour: number;
  minute: number;
  second: number;
} {
  if (typeof ms !== 'number' || Number.isNaN(ms) || ms < 0) {
    throw new Error('Invalid input: ms must be a non-negative number.');
  }

  const day = Math.floor(ms / (24 * 60 * 60 * 1000));
  const hour = Math.floor((ms % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minute = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));
  const second = Math.floor((ms % (60 * 1000)) / 1000);

  return { day, hour, minute, second };
}

export default formatMillisecondsToTimeUnit;
